<template>
  <div class="check-box">
    <label class="checkbox-s" v-for="(item, index) in filteredContents" :key="index">
      <input type="radio" name="radio" :value="item.value" :checked="modelValue === item.value" @change="updateValue" />
      <span class="check-txt">{{ item.label }}</span>
    </label>
  </div>
</template>
<script setup>
import { formatNumberToPhone } from '@/common/utils/module/FormattingSupport';
import { MODAL_TYPE } from '@/common/constants/ConstCode';
import { computed } from 'vue';
import { isEmpty } from '@/common/utils/Util';
const emits = defineEmits(['update:modelValue']);

const props = defineProps({
  items: {
    type: Array,
    default: [],
    required: true
  },
  type: {
    type: String,
    default: ''
  },
  modelValue: {
    type: [String, Object],
    default: ''
  }
});

// 보여줄 List 콘텐츠에 별도 처리가 필요할경우 해당 함수에서 type별로 구분하여 처리하면됨.
const filteredContents = computed(() => {
  switch (props.type) {
    case MODAL_TYPE.CHURCH:
      return props.items?.map(item => ({
        id: item.churchNo,
        label: `${item.churchName} (${item.state}, ${item.county})`,
        value: item.churchNo
      }));
    case MODAL_TYPE.FAMILY:
      return props.items?.map(item => ({
        id: item.familyName,
        label: !isEmpty(item.birthDate)
          ? `${item.name} (${item.birthDate} / ${formatNumberToPhone(item.phone)})`
          : `${item.name}`,
        value: item.familyCode
      }));
    default:
      return props.items;
  }
});

const updateValue = event => {
  const value = event.target.value;
  const result = filteredContents.value.find(element => String(element.value) === value);
  emits('update:modelValue', result);
};
</script>

<style scoped></style>
